import React, { ChangeEvent } from "react";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

type DialogTextFieldProps = {
  label: string;
  name?: string;
  rows?: number;
  inputValue?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

const DialogTextField: React.FC<DialogTextFieldProps> = ({
  label,
  name,
  rows,
  inputValue,
  onChange,
  disabled,
}) => {
  const labelStyle = {
    color: "black",
    fontFamily: "Lato",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    marginBottom: 1,
  };

  const inputStyle = {
    borderRadius: "8px",
    border: "1px solid #D0D1D3",
    background: disabled ? "#F5F5F5" : "#FFF",
    fontFamily: "Lato",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
  };

  return (
    <>
      <Typography variant="h3" {...labelStyle}>
        {label}
      </Typography>
      <TextField
        inputProps={{ "aria-label": label }}
        variant="outlined"
        fullWidth
        disabled={disabled}
        multiline={!!rows}
        rows={rows}
        value={inputValue}
        onChange={onChange}
        sx={{
          marginBottom: 2,
          "& .MuiInputBase-root": inputStyle,
        }}
      />
    </>
  );
};

export default DialogTextField;
